import { create } from "zustand";
import { addDiscount, deleteDiscount, discountCodes} from "../api_layer/api";

export const useDiscountCode = create((set) => ({
  discountData: [],
  discountLoading: false,
  addDiscountLoading:false,
  deleteLoading:false,
  error: null,
  fetchDiscountData: async () => {
    try {
      set({ discountLoading: true, error: null });
      const response = await discountCodes();
      set({ discountData: response.data, discountLoading: false });
    } catch (error) {
      set({ error: error.message, discountLoading: false });
    }
  },
  deleteDiscountData: async (id, setToaster, fetchDiscountData) => {
    try {
      set({ deleteLoading: true, error: null });
      const response = await deleteDiscount(id);
      setToaster("Discount Code", "Deleted Successfully", "success");
      fetchDiscountData();
      set({ deleteLoading: false });

    } catch (error) {
        setToaster("Discount Code", "Discount Added Failed", "danger");
      set({ error: error.message, deleteLoading: false });
    }
  },
  postDiscountData: async (payload, setToaster, fetchDiscountData, handleModalShow) => {
    try {
      set({ addDiscountLoading: true, error: null });
      const response = await addDiscount(payload);
      setToaster("Add Discount", "Discount Code Added Successfully", "success");
      fetchDiscountData();
      handleModalShow();
      set({ addDiscountLoading: false });
    } catch (error) {
      if(error.response.status==='500'){
        setToaster("Add Discount", "Discount code already exist", "info")
      }
      else{
        setToaster("Add Discount", "Failed to add new Discount Code", "danger")
      }
      set({ error: error.message, addDiscountLoading: false });
      handleModalShow();
    }
  },

}));
